var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwentyfive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #1f2f60;\n      }\n\n      .cls-2 {\n        opacity: .84;\n      }\n\n      .cls-3 {\n        fill: #ccc;\n      }\n\n      .cls-4 {\n        fill: #eaeaea;\n        opacity: .19;\n      }\n\n      .cls-5 {\n        fill: #dcdbdb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.9,431.8l-89.75-89.76c-13.65-13.65-13.65-35.78,0-49.43,13.65-13.65,35.78-13.65,49.43,0l89.76,89.75-49.43,49.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M500.3,1018.63c-36.58,0-66.23-29.65-66.23-66.23v-86.46h132.46v86.46c0,36.58-29.65,66.23-66.23,66.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M787.11,917.89c-36.58,0-66.23-29.65-66.23-66.22v-86.46h132.45v86.46c0,36.58-29.65,66.22-66.22,66.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.13,891.02c-36.58,0-66.22-29.65-66.22-66.23v-135.7h132.45v135.7c0,36.58-29.65,66.23-66.23,66.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.82,410.86c-90.33,156.46-16.09,368.45,165.83,473.48s402.62,63.34,492.97-93.12c90.33-156.46,16.09-368.45-165.83-473.48-181.92-105.03-402.63-63.34-492.97,93.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M494.11,560.44c21.17-24.88,46.69-48.19,76.11-68.62,7.62-5.29,15.33-10.24,23.1-14.9l-15.67-22.02c-17.86-25.11-54.67-26.92-82.2-4.04-27.54,22.87-35.37,61.77-17.5,86.87l16.16,22.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M836.14,434.13l3.8-30.84c3.57-28.93-16.24-49.43-44.23-45.79-27.99,3.64-53.57,30.04-57.14,58.97l-1.2,9.78c35.49-4.03,69.22-1.41,98.77,7.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M817.4,429.28l2.1-17.02c2.18-17.71-9.95-30.26-27.08-28.03s-32.8,18.39-34.99,36.1l-.53,4.35c21.18-.95,41.52.6,60.5,4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M511.39,541.49c17.34-17.78,37.02-34.53,58.84-49.67.66-.46,1.32-.89,1.99-1.34l-9.94-13.96c-10.93-15.38-33.47-16.48-50.33-2.47-16.85,14-21.65,37.82-10.72,53.19l10.15,14.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M919.13,681.34c0,50.44-41.92,115.54-93.62,145.39-51.71,29.85-93.63,13.16-93.63-37.29s41.92-115.55,93.63-145.4c51.7-29.85,93.62-13.16,93.62,37.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M788.23,811.56l-2.25,1.3c-8.34,4.81-15.1-.3-15.1-11.42v-69.01c0-11.12,6.76-24.04,15.1-28.85l2.25-1.31c8.34-4.81,15.1.3,15.1,11.42v69.02c0,11.12-6.76,24.04-15.1,28.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M865.05,767.21l-2.25,1.3c-8.34,4.82-15.1-.3-15.1-11.41v-69.02c0-11.12,6.76-24.04,15.1-28.85l2.25-1.31c8.34-4.81,15.1.3,15.1,11.42v69.02c0,11.12-6.76,24.04-15.1,28.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M710.49,638.32c0,15.17-12.3,27.48-27.48,27.48s-27.48-12.31-27.48-27.48,12.3-27.48,27.48-27.48,27.48,12.3,27.48,27.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M891.4,563.5c0,15.18-12.3,27.48-27.48,27.48s-27.47-12.3-27.47-27.48,12.3-27.48,27.47-27.48,27.48,12.3,27.48,27.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M647.46,446.03c-7.11,0-14.21-2.78-19.52-8.3-.56-.58-56.83-58.06-154.51-93.86-14.05-5.15-21.26-20.71-16.11-34.76s20.71-21.26,34.76-16.11c110.1,40.35,172.35,104.49,174.95,107.2,10.35,10.81,9.98,27.96-.83,38.31-5.24,5.02-12,7.52-18.73,7.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M692.22,245.66c0-72.77-44.24-157.31-98.82-188.82-22.8-13.16-43.78-14.95-60.5-7.31v-.04s-44.08,25.68-44.08,25.68c0,0-36.59,14.72-36.59,81.23,0,72.77,44.24,157.31,98.82,188.82,27.01,15.59,51.48,15.26,69.32,2.14h0s37.67-21.82,37.67-21.82c20.93-12.09,34.18-40.08,34.18-79.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M649.87,270.51c0,72.77-44.25,106.22-98.82,74.71-54.58-31.51-98.83-116.05-98.83-188.82s44.25-106.22,98.83-74.71c54.57,31.51,98.82,116.05,98.82,188.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M618.89,252.63c0,49.95-30.37,72.92-67.84,51.28-37.47-21.63-67.84-79.67-67.84-129.62s30.37-72.92,67.84-51.28c37.47,21.63,67.84,79.67,67.84,129.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M597.85,240.48c0,34.47-20.95,50.3-46.81,35.38-25.85-14.92-46.81-54.96-46.81-89.43s20.95-50.3,46.81-35.38c25.85,14.92,46.81,54.96,46.81,89.43Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwentyfive);
export default __webpack_public_path__ + "static/media/twentyfive.9f5e30fba1ca2e1d4a4b8b4393ad78d5.svg";
export { ForwardRef as ReactComponent };